import WeeklyView from "./components/WeeklyView";
import Error from "../../components/Error";
import { checkAccess } from "../../utilities/userAccess";
import DailyView from "./components/DailyView";
import { useSearchParams } from "react-router-dom";

const Dashboard = (props) => {
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientid");
  const userAccess = checkAccess("1");
  return (
    <>
      {userAccess ? (
        <div className="dashboard-grid">
          <DailyView clientId={clientId} />
          <WeeklyView clientId={clientId} />
        </div>
      ) : (
        <Error line1="Access Denied" line2="" line3="" />
      )}
    </>
  );
};

export default Dashboard;
